import { Star, Quote, ExternalLink, ThumbsUp } from "lucide-react";
import { TESTIMONIALS, REVIEW_STATS } from "@/lib/siteData";

export const Testimonials = () => {
  return (
    <section
      id="reviews"
      data-testid="testimonials-section"
      className="py-20 sm:py-28 lg:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <span className="inline-block text-green-700 font-semibold text-sm uppercase tracking-widest">
              Social proof
            </span>
            <h2
              data-testid="testimonials-headline"
              className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 tracking-tight"
              style={{ fontFamily: "Outfit, sans-serif" }}
            >
              {REVIEW_STATS.recommendPercent}% recommended by local homeowners.
            </h2>
            <p className="mt-4 text-slate-600 text-base lg:text-lg">
              Based on {REVIEW_STATS.count} {REVIEW_STATS.source} reviews — every single one a recommend.
            </p>
          </div>

          <a
            href={REVIEW_STATS.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="testimonials-rating-summary"
            className="inline-flex items-center gap-3 px-5 py-4 rounded-2xl border border-slate-200 bg-slate-50 hover:bg-white hover:border-blue-300 hover:shadow-md transition-all group"
          >
            <div className="w-11 h-11 rounded-xl bg-green-600 text-white flex items-center justify-center">
              <ThumbsUp className="w-5 h-5" fill="currentColor" />
            </div>
            <div className="text-left">
              <div className="flex items-center gap-1">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star
                    key={i}
                    className="w-4 h-4 text-yellow-500"
                    fill="currentColor"
                  />
                ))}
                <span className="ml-2 font-bold text-slate-900">
                  {REVIEW_STATS.recommendPercent}% recommend
                </span>
              </div>
              <div className="text-xs text-slate-500 mt-0.5">
                Based on {REVIEW_STATS.count} {REVIEW_STATS.source} reviews
              </div>
            </div>
            <ExternalLink className="w-4 h-4 text-slate-400 group-hover:text-blue-700 transition-colors" />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <article
              key={i}
              data-testid={`testimonial-card-${i}`}
              className="relative bg-slate-50 rounded-2xl p-6 border border-slate-100 hover:border-blue-200 transition-colors flex flex-col"
            >
              <Quote className="absolute top-5 right-5 w-7 h-7 text-blue-100" />
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, k) => (
                  <Star
                    key={k}
                    className="w-4 h-4 text-yellow-500"
                    fill="currentColor"
                  />
                ))}
              </div>
              <p className="text-slate-700 leading-relaxed text-sm flex-1">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-slate-200 flex items-center justify-between">
                <div>
                  <div
                    className="font-semibold text-slate-900"
                    style={{ fontFamily: "Outfit, sans-serif" }}
                  >
                    {t.name}
                  </div>
                  <div className="text-xs text-slate-500">{t.location}</div>
                </div>
                <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-widest font-bold text-blue-700 bg-blue-50 px-2 py-1 rounded-full">
                  <ThumbsUp className="w-3 h-3" fill="currentColor" />
                  Recommends
                </span>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href={REVIEW_STATS.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="testimonials-see-all-link"
            className="inline-flex items-center gap-2 text-sm font-semibold text-blue-700 hover:text-blue-900 underline-offset-4 hover:underline"
          >
            See all reviews on Facebook
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
